export const buildOtherPanelInfoQuery = (u6me2, differentialCircutor, additionalPanelOutputs) => {
  //a partir del estado o flag de cada tipo de salida genera una query para la peticion de solo lo
  //que se necesita.
  let query = 'panels?fields=id'
  if (u6me2 === 1) { //tridonic
    query += ',u6me2_profile1_id,u6me2_profile2_id,u6me2_profile3_id,u6me2_profile4_id'
  }
  if (differentialCircutor === 1) { //circutor diferencial
    query += ',circutor_profile_id'
  }
  if (additionalPanelOutputs === 1) { //salidas digitales
    query += ',on_off_schedule5_profile_type,on_off_schedule6_profile_type,on_off_schedule7_profile_type,on_off_schedule8_profile_type'
  }
  if (additionalPanelOutputs === 2) { //salidas de relé
    query += ',on_off_schedule5_profile_id,on_off_schedule6_profile_id,on_off_schedule7_profile_id,on_off_schedule8_profile_id'
  }
  return query;
}